import { createTelemetryAPI } from '~/utils/telemetry'

export const comparisonReportTelemetry = createTelemetryAPI(({ track }) => ({
  createReport(orgId: string, clusterId: string, params: any) {
    return track('Comparison Report: Create Report', {
      orgId,
      clusterId,
      params
    })
  },
  viewReport(msg: { orgId: string; clusterId: string; reportId: string }) {
    return track('Comparison Report: View Report', msg)
  },
  deleteReport(msg: { orgId: string; clusterId: string; reportId: string }) {
    return track('Comparison Report: Delete Report', msg)
  }
}))
